import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { UsagePaymentsRoutingModule } from './usage-payments-routing.module';
import { UsagePaymentDetailsComponent } from './usage-payment-details/usage-payment-details.component';
import { UsagePaymentsService } from './usage-payments.service';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule, MatDividerModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatTooltipModule
} from '@angular/material';
import { DppUsageComponent } from './dpp-usage/dpp-usage.component';
@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    UsagePaymentsRoutingModule,
    CdkTableModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTooltipModule,
    MatCardModule,
    MatDividerModule
  ],
  providers: [UsagePaymentsService, TitleCasePipe],
  declarations: [UsagePaymentDetailsComponent, DppUsageComponent]
})
export class UsagePaymentsModule { }



// WEBPACK FOOTER //
// ./src/app/payment/usage-payments/usage-payments.module.ts